import React, { ReactNode } from "react";
import mediaQueries from "~/components/mediaQueries";

interface IVendorOwnerNavbarProps {
  children: ReactNode;
}

export default function VendorOwnerNavbar({ children }: IVendorOwnerNavbarProps) {
  return (
    <div
      css={mediaQueries({
        padding: "16px 0px",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        textAlign: "center",
        alignItems: "left",
      })}
    >
      {children}
    </div>
  );
}
